module.exports = __webpack_public_path__ + "img/draw-title.25d2a35f.png";